export default function(observers) {
  observers.forEach(item => {
    this.observers.push(item);
  });
}
